import { defineNuxtPlugin } from '#app'
import { init } from '@plausible-analytics/tracker'

export default defineNuxtPlugin(() => {
  console.log('[Plausible] Calling init for analytics tracker...')
  const plausible = init({
    domain: 'kudosales.com',
    autoCapturePageviews: false,
    captureOnLocalhost: true,
  })
  console.log('[Plausible] init called, tracker instance:', plausible) // plausible är alltid undefined

  return {
    provide: {
      plausible
    }
  }
})